import { products } from '../../../mocks/products';

interface RelatedProductsProps {
  currentProductId: number;
  category: string;
}

export default function RelatedProducts({ currentProductId, category }: RelatedProductsProps) {
  const relatedProducts = products
    .filter(p => p.category === category && p.id !== currentProductId)
    .slice(0, 4);

  if (relatedProducts.length === 0) return null;

  return (
    <div className="space-y-8">
      <div className="text-center">
        <h2 className="text-3xl font-bold text-white mb-2">Complete The Look</h2>
        <p className="text-white/60">Curated pieces that pair perfectly</p>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-4 gap-6" data-product-shop>
        {relatedProducts.map((product) => (
          <a
            key={product.id}
            href={`/product/${product.id}`}
            className="group"
          >
            <div className="relative w-full h-80 bg-black/20 rounded-lg overflow-hidden mb-4">
              <img
                src={product.image}
                alt={product.name}
                className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-110"
              />
              <div className="absolute inset-0 bg-black/0 group-hover:bg-black/20 transition-colors duration-300" />
              
              {/* Quick View Button */}
              <button className="absolute bottom-4 left-1/2 -translate-x-1/2 bg-white text-black px-6 py-2 rounded-full font-medium text-sm opacity-0 group-hover:opacity-100 transition-opacity duration-300 whitespace-nowrap">
                Quick View
              </button>
            </div>

            <div className="space-y-1">
              <h3 className="text-white font-medium group-hover:text-white/80 transition-colors">
                {product.name}
              </h3>
              <p className="text-white/60 text-sm">${product.price}</p>
            </div>
          </a>
        ))}
      </div>
    </div>
  );
}